module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page no-top-nav no-side-space subscribe-landing"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('v-container', {
    staticClass: "banner-container"
  }, [_c('div', {
    staticClass: "banner-content"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Join the world’s creators & music lovers.")]), _vm._v(" "), _c('p', {
    staticClass: "_subtitle"
  }, [_vm._v("Start your free 30 day trial")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#plans"
    }
  }, [_c('v-btn', {
    staticClass: "white",
    attrs: {
      "round": ""
    }
  }, [_vm._v("Choose Plan")])], 1)])])], 1), _vm._v(" "), _c('v-container', {
    staticClass: "learnmore-comp"
  }, [_c('learn-more', {
    attrs: {
      "pageMode": "",
      "setOnMobile": "",
      "hideFooter": ""
    }
  })], 1), _vm._v(" "), _c('v-container', {
    staticClass: "plans-container pb-5 mb-5",
    attrs: {
      "id": "plans"
    }
  }, [_c('h1', {
    staticClass: "main-title intro-title"
  }, [_vm._v("Choose Plan")]), _vm._v(" "), _c('hr', {
    staticClass: "light"
  }), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center justify-space-between top-note"
  }, [_c('div', {
    staticClass: "_left"
  }, [_vm._v("Cancel anytime.")]), _vm._v(" "), _c('div', {
    staticClass: "_right"
  }, [_vm._v("* SMS costs $0.01 per text")])]), _vm._v(" "), _c('div', {
    staticClass: "plans"
  }, _vm._l((_vm.plans), function(plan, index) {
    return _c('div', {
      key: index,
      staticClass: "plan",
      class: [("plan_" + index), ("plan_" + (plan.id))]
    }, [_c('div', [_c('h2', {
      staticClass: "plan_title"
    }, [_vm._v(_vm._s(plan.title))]), _vm._v(" "), _c('div', {
      staticClass: "plan_lists"
    }, _vm._l((plan.list), function(item, i) {
      return _c('div', {
        key: i,
        staticClass: "plan_list"
      }, [((typeof item === 'string')) ? _c('div', {
        staticClass: "top_item"
      }, [_c('v-icon', [_vm._v("check")]), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(item)
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t\t\t\t")])], 1) : _c('div', _vm._l((item), function(innerItem, i) {
        return _c('div', {
          key: i,
          staticClass: "innerItem dflex"
        }, [_c('span', {
          staticClass: "_bullet"
        }, [_vm._v("•")]), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(innerItem)
          }
        }, [_vm._v(_vm._s(innerItem))])])
      }))])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "pricing-absolute"
    }, [_c('div', {
      staticClass: "pricing"
    }, [_c('span', {
      staticClass: "currency"
    }, [_vm._v("$")]), _vm._v(" "), _c('span', {
      staticClass: "cost"
    }, [_vm._v(_vm._s(plan.price))]), _vm._v(" "), _c('span', {
      staticClass: "per"
    }, [_vm._v("/month")])]), _vm._v(" "), _c('div', {
      staticClass: "plan_btn_wrapper"
    }, [_c('v-btn', {
      staticClass: "plan_btn py-4",
      attrs: {
        "depressed": "",
        "block": "",
        "round": "",
        "dark": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.verifyUserType(plan)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.plansDescription(plan.id)))])])], 1)])])
  }))]), _vm._v(" "), _c('v-container', {
    staticClass: "faq-container"
  }, [_c('h1', {
    staticClass: "main-title mb-3"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('hr', {
    staticClass: "light mb-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "faqs"
  }, [_c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("How can I pay for a subscription?")]), _vm._v(" "), _c('div', [_vm._v("You can pay with accepted credit cards.")])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("How does the 30 day trial work?")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\tStart a free trial to get full access to all features. Simply add a\n\t\t\t\t\tvalid credit card, your card will be "), _c('br'), _vm._v(" automatically charged 30 days\n\t\t\t\t\tafter your trial starts and you will be charged on a monthly basis.\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("How do I change my subscription?")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\tGo to "), _c('strong', [_vm._v("Settings")]), _vm._v(" and tap\n\t\t\t\t\t"), _c('strong', [_vm._v("Subscriptions")]), _vm._v(", if on desktop, go to\n\t\t\t\t\t"), _c('strong', [_vm._v("Settings > Accounts")]), _vm._v(", then tap the plan you"), _c('br'), _vm._v(" want &\n\t\t\t\t\tconfirm. If it’s an upgraded plan you will enter a card to start a\n\t\t\t\t\tfree trial, if you already have a"), _c('br'), _vm._v(" premium subscription the upgrade\n\t\t\t\t\tprice difference will be pro-rated and billed on the next cycle.\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("How do I cancel my subscription?")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\tGo to "), _c('strong', [_vm._v("Settings")]), _vm._v(" and tap\n\t\t\t\t\t"), _c('strong', [_vm._v("Subscriptions")]), _vm._v(", if on desktop, go to\n\t\t\t\t\t"), _c('strong', [_vm._v("Settings > Accounts")]), _vm._v(", then tap Free and"), _c('br'), _vm._v(" confirm.\n\t\t\t\t\tYour account will convert to “Preview Only” on the next payment\n\t\t\t\t\tcycle.\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("Can I listen offline?")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\tCurrently, no, however you can download songs you love & support\n\t\t\t\t\tcreators directly,"), _c('br'), _vm._v(" they keep 100% of their sales.\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("How do creators share my subscription?")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t50% of your monthly subscription is paid directly to the top 10\n\t\t\t\t\tcreators you stream the most that month. If you"), _c('br'), _vm._v(" stream 10 creators,\n\t\t\t\t\t$5 will be split between 10 creators at $0.50 cents, if you only\n\t\t\t\t\tstream one creator the entire"), _c('br'), _vm._v("  month, they will earn the entire $5.\n\t\t\t\t")])])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "plans-dialog"
    },
    model: {
      value: (_vm.initPayment),
      callback: function($$v) {
        _vm.initPayment = $$v
      },
      expression: "initPayment"
    }
  }, [_c('payment-card', {
    attrs: {
      "item": _vm.selectedPlan,
      "totalPayable": _vm.totalPayable,
      "closePayment": _vm.closePaymentModal
    }
  })], 1), _vm._v(" "), (_vm.currentUser !== null && _vm.currentUser.plan !== null) ? _c('v-dialog', {
    model: {
      value: (_vm.plansUpgradeModal),
      callback: function($$v) {
        _vm.plansUpgradeModal = $$v
      },
      expression: "plansUpgradeModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Plan Changes")]), _vm._v(" "), (_vm.plansName[_vm.currentUser.plan] == 'Listener') ? _c('v-card-text', [_c('p', [_vm._v("Your current plan is "), _c('b', [_vm._v(" " + _vm._s(_vm.plansName[_vm.currentUser.plan]) + " ")]), _vm._v(" and you are trying to "), _c('b', [_vm._v(_vm._s(_vm.planChangeText) + ". ")])]), _vm._v(" "), _c('p', [_vm._v("You will remain listener until admin approve your account. Once you verified, you will be charged according to subscription of current plan and new chosen plan.\n\t\t\t\t\tAre you sure you want to continue?\n\t\t\t\t")])]) : _c('v-card-text', [_c('p', [_vm._v("Your current plan is "), _c('b', [_vm._v(" " + _vm._s(_vm.plansName[_vm.currentUser.plan]) + " ")]), _vm._v(" and you are trying to "), _c('b', [_vm._v(_vm._s(_vm.planChangeText) + ". ")])]), _vm._v(" "), _c('p', [_vm._v("This will have an immediate effect and you will be charged according to subscription of current plan and new chosen plan.\n\t\t\t\t\tAre you sure you want to continue?\n\t\t\t\t")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.subscriptionChange(_vm.planChangeText)
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hidePlanChangeModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0178a6f2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/subscribe/index.vue
// module id = 1598
// module chunks = 180